import { createMuiTheme, MuiThemeProvider } from "@material-ui/core";
import { ConnectedRouter } from "connected-react-router";
import * as React from "react";
import { useContext } from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./app";
import MainApp from "./MainApp";
import store from "./redux";
import history from "./redux/history";
import registerServiceWorker from "./registerServiceWorker";

const app = new App(store);
export const AppContext = React.createContext(app);

export function useApp() {
  return useContext(AppContext);
}

declare module "@material-ui/core/styles/createMuiTheme" {
  interface ThemeOptions {
    drawerWidth: number;
  }
  interface Theme {
    drawerWidth: number;
  }
}

const muiTheme = createMuiTheme({
  drawerWidth: 240,
  typography: {
    useNextVariants: true
  }
});

ReactDOM.render(
  <MuiThemeProvider theme={muiTheme}>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <AppContext.Provider value={app}>
          <MainApp />
        </AppContext.Provider>
      </ConnectedRouter>
    </Provider>
  </MuiThemeProvider>,
  document.getElementById("root") as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx